export class UtilType {
    static hasValue(val) {
        if (val === false || val === 0) {
            return true;
        }
        else if (!val) {
            return false;
        }
        const condition1 = val.length !== 0;
        const condition2 = typeof (val) === 'object' && Object.keys(val).length !== 0;
        return condition1 || condition2;
    }
    static isDefined(val) {
        return val !== null && typeof (val) !== 'undefined';
    }
    static isString(val) {
        return (typeof val === 'string' || val instanceof String);
    }
}
